import { render, staticRenderFns } from "./VacunaDosisMujer.vue?vue&type=template&id=2432bf27&scoped=true"
import script from "./VacunaDosisMujer.vue?vue&type=script&lang=js"
export * from "./VacunaDosisMujer.vue?vue&type=script&lang=js"
import style0 from "./VacunaDosisMujer.vue?vue&type=style&index=0&id=2432bf27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2432bf27",
  null
  
)

export default component.exports